import React from "react";
import styles from "../styles/styles";

export default function TrainStatusHeader({
    trainId = "A01",
    ub = "UB048",
    line = "Linha 8",
    cpb = true,
    ste = true,
    alarms = 0,
    carro1 = "JPR",
    carro8 = "IPV"
}) {
    return (
        <div style={styles.trainHeaderContainer}>

            {/* BLOCO 1 */}
            <div style={styles.trainHeaderBox}>
                <div style={styles.trainHeaderTitle}>{trainId}</div>
                <div style={styles.trainHeaderSubtitle}>{ub}</div>
            </div>

            {/* BLOCO 2 */}
            <div style={styles.trainHeaderOperationBox}>

                <div style={styles.trainHeaderOperationText}>
                    Em operação na Linha {line}
                </div>

                <div style={styles.trainHeaderSubBox}>
                    <div style={styles.trainHeaderSubItemLeft}>
                        {cpb ? "CPB" : "-"}
                    </div>

                    <div style={styles.trainHeaderSubItem}>
                        {ste ? "STE" : "-"}
                    </div>
                </div>
            </div>

            {/* BLOCO 3 */}
            <div style={styles.trainHeaderBox}>
                <div style={styles.trainHeaderSubtitle}>Alarmes ativos</div>
                <div style={styles.trainHeaderBigValue}>
                    {alarms > 0 ? alarms : "0"}
                    {/* {alarms > 0 ? alarms : "X"} */}
                </div>
            </div>

            {/* BLOCO 4 */}
            <div style={styles.trainHeaderBox}>
                <div style={styles.trainHeaderSubtitle}>Carro 1</div>
                {/* <div style={styles.trainHeaderValue}>{carro1}</div> */}
                <div style={styles.trainHeaderValue}>{"-"}</div>
            </div>

            {/* BLOCO 5 */}
            <div style={styles.trainHeaderBox}>
                <div style={styles.trainHeaderSubtitle}>Carro 8</div>
                {/* <div style={styles.trainHeaderValue}>{carro8}</div> */}
                <div style={styles.trainHeaderValue}>{"-"}</div>
            </div>

        </div>
    );
}